import { VueCookies } from 'vue-cookies'
import AuthService from '@/services/authService'

import { useUserStore } from '@/store/user'
import { useAppStore } from '@/store/app'
import { useAppCookies } from '@/composables/useCookies'

export const logout = (redirectPath?: string) => {
  // prevent initialization before pinia by initializing stores at runtime
  const userStore = useUserStore()
  const appStore = useAppStore()
  const { cookies } = useAppCookies()

  const authService = new AuthService()
  authService.logout()
  userStore.setUser(null)
  appStore.setSelectedBusinessProfileId(null)
  authService.clearAuthData(cookies)

  const loginRoute = {
    path: import.meta.env.VITE_APP_LOGIN_URL
  }

  // Extract the existing decoded redirect query parameter
  const decodedRedirect = redirectPath ?? window.location.pathname.substring(1)
  const encodedRedirect = decodedRedirect
    ? encodeURIComponent(decodedRedirect)
    : ''
  window.location.href = `${loginRoute.path}?redirect=${encodedRedirect}`
}
